// node modules
import React from 'react';
import { observer } from 'mobx-react';
// ui library
import { HighLowValue, Text, View } from '@upstox/upstox-ui';
// modules
import { useStore } from 'modules/Stores';
import FormatService from 'modules/Format';
// typings
import { DATA_SETTINGS } from 'modules/OptionChain/consts';
// styles
import * as css from '../styles';
// components
import OptionChainCell from '../OptionChainCell/OptionChainCell';

const OptionChainLtpCell: React.FC<OptionChainTableCellProps> = ({
  instrumentKey,
}) => {
  const {
    tableSettings: {
      dataSettings: { changeIn },
    },
  } = useStore('OptionChainStore');
  const { getOptionParamValueWithInstrumentKey } = useStore('LiveDataStore');

  const lastTradedPrice = getOptionParamValueWithInstrumentKey(
    instrumentKey,
    'lastTradedPrice',
  );
  const close = getOptionParamValueWithInstrumentKey(instrumentKey, 'close');

  const ltp = lastTradedPrice
    ? `${FormatService.formatToIndianFloat(lastTradedPrice)}`
    : '--';

  const {
    ltpChange: change,
    value,
    percentageChange,
  } = FormatService.getLtpChange(lastTradedPrice, close, false);

  return (
    <OptionChainCell>
      <View flex alignItems="baseline" justifyContent="center" gap="xsmall">
        <Text
          variant="meta"
          color="text.1"
          size="m"
          lineHeight="l"
          css={css.optionChainCell}
        >
          {ltp}
        </Text>

        <HighLowValue
          variant="meta"
          ltpChange={change}
          size="s"
          lineHeight="l"
          css={css.optionChainCell}
        >
          {`(${
            changeIn === DATA_SETTINGS.changePer
              ? `${change < 0 ? '-' : ''}${percentageChange}%`
              : value
          })`}
        </HighLowValue>
      </View>
    </OptionChainCell>
  );
};

export default observer(OptionChainLtpCell);
